export default __webpack_public_path__ + "static/media/online.1148452e.svg";